import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { DomainMessages } from '@packages/shared/i18n/DomainMessages';
import { Language } from '@packages/shared/domain/user/Language';

import enAgenda from '@/locales/en/agenda.json';
import enAssistant from '@/locales/en/assistant.json';
import enAuth from '@/locales/en/auth.json';
import enCommon from '@/locales/en/common.json';
import enErrors from '@/locales/en/errors.json';
import enNavigation from '@/locales/en/navigation.json';
import enNotifications from '@/locales/en/notifications.json';
import enProfile from '@/locales/en/profile.json';
import enValidation from '@/locales/en/validation.json';
import enWorkOrders from '@/locales/en/workOrders.json';
import esAgenda from '@/locales/es/agenda.json';
import esAssistant from '@/locales/es/assistant.json';
import esAuth from '@/locales/es/auth.json';
import esCommon from '@/locales/es/common.json';
import esErrors from '@/locales/es/errors.json';
import esNavigation from '@/locales/es/navigation.json';
import esNotifications from '@/locales/es/notifications.json';
import esProfile from '@/locales/es/profile.json';
import esValidation from '@/locales/es/validation.json';
import esWorkOrders from '@/locales/es/workOrders.json';

i18n.use(initReactI18next).init({
	resources: {
		en: {
			agenda: enAgenda,
			assistant: enAssistant,
			auth: enAuth,
			common: enCommon,
			[DomainMessages.NAMESPACE]: DomainMessages.forLanguage(Language.EN),
			errors: enErrors,
			navigation: enNavigation,
			notifications: enNotifications,
			profile: enProfile,
			validation: enValidation,
			workOrders: enWorkOrders,
		},
		es: {
			agenda: esAgenda,
			assistant: esAssistant,
			auth: esAuth,
			common: esCommon,
			[DomainMessages.NAMESPACE]: DomainMessages.forLanguage(Language.ES),
			errors: esErrors,
			navigation: esNavigation,
			notifications: esNotifications,
			profile: esProfile,
			validation: esValidation,
			workOrders: esWorkOrders,
		},
	},
	lng: 'es',
	fallbackLng: 'en',
	ns: [
		'agenda',
		'assistant',
		'auth',
		'common',
		DomainMessages.NAMESPACE,
		'errors',
		'navigation',
		'notifications',
		'profile',
		'validation',
		'workOrders',
	],
	defaultNS: 'common',
	interpolation: {
		escapeValue: false,
	},
});

export default i18n;
